import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import icons from "../../assets/images/sprite-other-icons.svg";
import {
  setSelectedGamesList,
  setViewAllModal,
} from "../home/cl_LoyalltyCoins";
import {
  setSearchInput,
  setFilteredGames,
  getAllGames,
} from "../crashGames/cl_CrashSlice";
import statickImg from "../../assets/images/popup/staticImg.png";

const ViewAllModal = (props) => {
  const { selectedGamesList } = props;
  const [localSelectedGames, setLocalSelectedGames] = useState([]);
  const [gamesMaxLimit, setGamesMaxLimit] = useState(false);
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("");

  const { staticContent } = useSelector((state) => state?.topGamesList);
  const { searchInput, filteredGames, getAllgamesList } = useSelector(
    (state) => state?.crash
  );

  const [categories, setCategories] = useState([]);
  const [activeTabGames, setActiveTabGames] = useState([]);
  const [allGames, setAllGames] = useState([]);
  const [displayGames, setDisplayGames] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    dispatch(getAllGames());
  }, [dispatch]);

  useEffect(() => {
    if (getAllgamesList && getAllgamesList.length > 0) {
      const uniqueCategories = getAllgamesList.map((category) => ({
        name: category.game_type,
        icon: category.categoryicon || "",
      }));

      setCategories(uniqueCategories);

      if (uniqueCategories.length > 0) {
        setActiveTab(uniqueCategories[0].name);
      }

      const combinedGames = getAllgamesList.reduce((acc, category) => {
        const gamesWithCategory = (category.game || []).map((game) => ({
          ...game,
          category_type: category.game_type,
        }));
        return [...acc, ...gamesWithCategory];
      }, []);

      setAllGames(combinedGames);
      setIsLoading(false);
    }
  }, [getAllgamesList]);

  useEffect(() => {
    if (activeTab && getAllgamesList) {
      const categoryGames = getAllgamesList.find(
        (category) => category.game_type === activeTab
      );

      if (categoryGames && categoryGames.game) {
        setActiveTabGames(categoryGames.game);
        if (!searchInput) {
          setDisplayGames(categoryGames.game);
        }
      } else {
        setActiveTabGames([]);
        if (!searchInput) {
          setDisplayGames([]);
        }
      }
    }
  }, [activeTab, getAllgamesList, searchInput]);

  useEffect(() => {
    if (searchInput && searchInput.length > 0) {
      const searchTerm = searchInput.toLowerCase();

      const searchResults = allGames.filter((game) => {
        if (!game) return false;

        const gameName = (game.name || "").toLowerCase();
        const provider = (game.provider || "").toLowerCase();
        const gameCode = (game.game_code || "").toLowerCase();

        return (
          gameName.includes(searchTerm) ||
          provider.includes(searchTerm) ||
          gameCode.includes(searchTerm)
        );
      });

      dispatch(setFilteredGames(searchResults));
      setDisplayGames(searchResults);
    } else {
      if (activeTab && getAllgamesList) {
        const categoryGames = getAllgamesList.find(
          (category) => category.game_type === activeTab
        );

        if (categoryGames && categoryGames.game) {
          setDisplayGames(categoryGames.game);
        } else {
          setDisplayGames([]);
        }
      }
      dispatch(setFilteredGames([]));
    }
  }, [searchInput, allGames, activeTab, getAllgamesList, dispatch]);

    useEffect(() => {
      const initialGames = selectedGamesList?.filter(game => game.active).map((game) => ({
        ...game,
        game_code: game.game_code || game.gameCode,
        active: true
      })) || [];
      setLocalSelectedGames(initialGames);
    }, [selectedGamesList]);

  const handleGameClick = (e, game) => {
    const isGameSelected = localSelectedGames.some(
      (selectedGame) =>
        selectedGame.game_code === game.game_code ||
        selectedGame.gameCode === game.game_code
    );

    if (isGameSelected) {
      const updatedGames = localSelectedGames.filter(
        (selectedGame) =>
          !(selectedGame.game_code === game.game_code ||
          selectedGame.gameCode === game.game_code)
      );
      setLocalSelectedGames(updatedGames);
    } else {
      const activeGamesCount = localSelectedGames.filter(
        (game) => game.active
      ).length;
      if (activeGamesCount < 5) {
        setLocalSelectedGames([
          ...localSelectedGames,
          { 
            ...game, 
            active: true,
            aggregator: game.aggregator || game.aggregator_type || ''
          },
        ]);
      } else {
        setGamesMaxLimit(true);
        setTimeout(() => {
          setGamesMaxLimit(false);
        }, 2000);
      }
    }
};

  const handleSearchData = (event) => {
    event.preventDefault();
    dispatch(setSearchInput(event.target.value));
  };

  const handleTabClick = (tabName) => {
    setGamesMaxLimit(false);
    setActiveTab(tabName);
    dispatch(setSearchInput(""));
  };

  const handleSaveAndClose = () => {
    dispatch(setSelectedGamesList(localSelectedGames));
    dispatch(setViewAllModal(false));
  };

  const renderGamesList = () => {
    if (isLoading) {
      return (
        <div className="SB-msgBox">
          <div className="SB-msgBox-container">Loading games...</div>
        </div>
      );
    }

    if (!displayGames || displayGames.length === 0) {
      return (
        <div className="SB-msgBox">
          <div className="SB-msgBox-container">
            {searchInput && searchInput.length > 0
              ? "No games match your search."
              : "No games available for this category."}
          </div>
        </div>
      );
    }

    return (
      <div className="SB-gamesList">
        <ul>
          {displayGames.map((game, index) => {
            if (!game) return null;

            const gameObj = {
              game_code: game.game_code,
              name: game.name || "Unnamed Game",
              image: game.image,
              provider: game.provider,
              aggregator: game.aggregator_type || 'default_aggregator', 
              index: index,
            };

            const isSelected = localSelectedGames.some(
              (selectedGame) =>
                (selectedGame.game_code === gameObj.game_code ||
                  (selectedGame.gameCode === gameObj.game_code &&
                    selectedGame.name === gameObj.name)) &&
                selectedGame.active
            );

            return (
              <li
                key={`${gameObj.game_code || index}-${gameObj.name}-${index}`}
                className={isSelected ? "active" : ""}
                onClick={(e) => handleGameClick(e, gameObj)}
              >
                <div className="SB-gameItem">
                  <img
                    src={
                      (gameObj.image?.configurl || gameObj.image?.url) ===
                      "NoIcon"
                        ? statickImg
                        : gameObj.image?.configurl ||
                          gameObj.image?.url ||
                          statickImg
                    }
                    alt={gameObj.name}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = statickImg;
                    }}
                  />
                  <div className="SB-gameTitle">
                    {gameObj?.name
                      ? gameObj.name.charAt(0).toUpperCase() +
                        gameObj.name.slice(1).toLowerCase()
                      : ""}
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    );
  };

  return (
    <div
      className="SB-modal SB-viewallGames SB-modal-fullscreen"
      id="SB-viewallGames-modal"
      style={{ display: "block" }}
    >
      <div className="SB-modal-dialog">
        <div className="SB-modal-content">
          <div
            className="SB-modal-close"
            data-dismiss="modal"
            onClick={handleSaveAndClose}
          >
            <div className="SB-iconSVG" title="close">
              <svg xmlns="http://www.w3.org/2000/svg">
                <use xlinkHref={`${icons}#icon-close`} />
              </svg>
            </div>
          </div>
          <div className="SB-modal-body">
            <div className="SB-modal-header">
              <div className="SB-modal-title">All Games</div>
            </div>
            <div className="SB-searchBox-container">
              <div className="SB-searchBox">
                <input
                  type="text"
                  className="SB-inputField"
                  placeholder="Search"
                  value={searchInput}
                  autoComplete="off"
                  onChange={handleSearchData}
                />
                {searchInput?.length > 0 ? (
                  <div
                    className="SB-searchClear"
                    onClick={() => {
                      dispatch(setSearchInput(""));
                    }}
                  >
                    <div className="SB-iconSVG">
                      <svg xmlns="http://www.w3.org/2000/svg">
                        <use xlinkHref={`${icons}#icon-back-delete`}></use>
                      </svg>
                    </div>
                  </div>
                ) : (
                  <div className="SB-searchButton">
                    <div className="SB-iconSVG">
                      <svg xmlns="http://www.w3.org/2000/svg">
                        <use xlinkHref={`${icons}#icon-search`}></use>
                      </svg>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {!searchInput && (
              <div className="SB-tabs">
                <ul className="nav">
                  {categories.map((category, index) => (
                    <li key={index}>
                      <a
                        className={`SB-tab-item nav-link ${
                          activeTab === category.name ? "active" : ""
                        }`}
                        onClick={() => handleTabClick(category.name)}
                      >
                        {category.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {gamesMaxLimit && (
              <div className="SB-msgBox SB-error">
                <div className="SB-msgBox-container">
                  <div className="SB-iconSVG">
                    <svg xmlns="http://www.w3.org/2000/svg">
                      <use xlinkHref={`${icons}#icon-alert`}></use>
                    </svg>
                  </div>
                  Oops! Max limit reached. Please unselect any game to select a
                  new one.
                </div>
              </div>
            )}

            {searchInput && filteredGames && filteredGames.length > 0 && (
              <div className="SB-msgBox SB-info">
                <div className="SB-msgBox-container">
                  Found {filteredGames.length} games matching "{searchInput}"
                </div>
              </div>
            )}

            <div className="SB-tab-content">
              <div className="SB-tab-pane active">{renderGamesList()}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewAllModal;
